import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";

export const useBenefitCard = () => {
    const [valueBenefit, setValueBenefit] = useState(0);
    const [limitBenefit, setLimitBenefit] = useState(0);
    const navigate = useNavigate();
    const faqs = [
        {
            question: "O que é um Cartão de Crédito Consignado?",
            answer: "É um tipo de cartão de crédito que funciona como os tradicionais, mas com a vantagem de ter o valor mínimo da fatura descontado diretamente do salário ou benefício, o que reduz o risco de atrasos no pagamento.",
        },
        {
            question: "Quais são os juros do Cartão de Crédito Consignado?",
            answer: "A taxa de juros do crédito rotativo é de 2,46% ao mês. Embora seja menor do que a de cartões comuns, o ideal é sempre pagar o valor total da fatura, além do mínimo que já é descontado automaticamente.",
        },
        {
            question: "Quem pode solicitar o Cartão de Crédito Consignado?",
            answer: "Aposentados e pensionistas do INSS e servidores públicos de órgãos conveniados com o BMG, desde que possuam margem consignável disponível.",
        },
        {
            question: "Em quais lugares posso usar o Cartão Consignado?",
            answer: "Você pode utilizá-lo para compras e pagamentos em qualquer estabelecimento credenciado à bandeira Mastercard, no Brasil ou no exterior, tanto online quanto presencialmente. Também é possível fazer saques* do limite disponível (*consulte as condições e encargos).",
        },
        {
            question: "Existe algum custo para liberar o Cartão?",
            answer: "A emissão da primeira ou segunda via pode ter uma pequena taxa, dependendo do seu convênio. Caso haja algum custo, você será informado antes de confirmar a contratação.",
        },
        {
            question: "O que é o Cartão Consignado Benefício Bmg?",
            answer: `É um cartão de crédito consignado que, além das funcionalidades tradicionais, oferece benefícios gratuitos como descontos em farmácias conveniadas, possibilidade de compras em lojas físicas ou online com a bandeira Mastercard, acúmulo de pontos no programa Mastercard® Surpreenda e saques* de até 70% do limite disponível.

Para clientes do convênio INSS, há ainda um Seguro de Vida gratuito, com coberturas como morte natural ou acidental, assistência funeral e descontos em farmácias que podem chegar a 80%.

Importante: o valor mínimo da fatura é descontado automaticamente da folha de pagamento.

*Sujeito a encargos. Consulte condições.`,
        },
        {
            question: "Quem pode ter o Cartão Benefício Bmg?",
            answer: "Aposentados, pensionistas do INSS e servidores de instituições conveniadas com o banco, desde que tenham margem consignável. Lembre-se: a emissão pode ter custo conforme o convênio, mas você será avisado com antecedência.",
        },
        {
            question: "Quais são os juros se eu pagar apenas o valor mínimo da fatura do Cartão Benefício?",
            answer: "As taxas variam conforme o seu convênio. Por isso, recomendamos sempre pagar o valor total da fatura, além do mínimo que já é descontado automaticamente. Assim, você evita encargos adicionais.",
        },
        {
            question: "Como posso utilizar o limite de crédito do meu Cartão Benefício?",
            answer: `O valor disponível pode ser usado para compras em lojas físicas ou online que aceitam a bandeira Mastercard, no Brasil e no exterior. Você também acumula pontos no Mastercard® Surpreenda e pode sacar até 70% do limite em terminais 24h da rede Cirrus, nas lojas help!, correspondentes Bmg ou canais de atendimento do banco.

*Sujeito a encargos. Consulte as condições.`,
        },
    ];


    function calculateLimit() {
        const factor = 2.8;
        const limit = valueBenefit * factor;
        setLimitBenefit(limit.toFixed(2));
    }

    useEffect(() => {
        calculateLimit();
    }, [valueBenefit])

    const getSubHeader = () => (<section style={{ zIndex: 5 }} className="hidden md:flex bg-[#462A71] w-full px-4 py-2 flex items-center justify-center gap-5 fixed">
        <a href="#AdvantagesBenefitCard" className="text-white hover:opacity-[0.7] text-sm">Vantagens</a>
        <a href="#BenefitCardAbout" className="text-white hover:opacity-[0.7] text-sm">Cartão Consignado</a>
        <a href="#CreditCard" className="text-white hover:opacity-[0.7] text-sm">Benefícios</a>
        <a href="#Faq" className="text-white hover:opacity-[0.7] text-sm">Ajuda</a>
    </section>)

    const onGoToRegister = () => navigate('/register');

    return {
        faqs,
        valueBenefit,
        limitBenefit,
        setValueBenefit,
        getSubHeader,
        onGoToRegister
    }
}